import React from "react";
import LocalStructures from "../modules/LocalStructures/LocalStructures";
export default function LocalStructuresPage() {
  return <LocalStructures />;
}
